import { useRecoilValue } from 'recoil'
import healthClaimFormAtom from '@/recoil/healthClaimForm'
import { HealthClaimModeEnum } from '@/constant/E_CLAIM'

const CompensationRequestByBankInputGroupHook = () => {
  const healthClaim = useRecoilValue(healthClaimFormAtom)
  const isCreateOrEditMode =
    healthClaim.mode === HealthClaimModeEnum.CREATE || healthClaim.mode === HealthClaimModeEnum.EDIT

  const content =
    'บัญชีธนาคารต้องเป็นบัญชีออมทรัพย์เท่านั้น และต้องชื่อเดียวกับผู้เอาประกันภัย กรณีผู้เอาประกันภัยเป็นเด็ก หากยังไม่มีบัญชีธนาคาร ให้ใช้บัญชีของบิดาหรือมารดาแทนเท่านั้น'

  const isRequired = { required: true, message: '' }

  return {
    isCreateOrEditMode,
    content,
    isRequired,
  }
}

export default CompensationRequestByBankInputGroupHook
